import React, {memo, useCallback, useState, Fragment, useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';
import moment from 'moment';

import { Checkbox, ShowItemsSelectPageCount, Message, Pagination } from '../../utilites';
import { ActionButton, ConfirmModal, AlertModal } from '../../common';
import {
  pageOptions,
  contractStatuses,
  viewDocument,
  viewReports,
} from '../../../helpers/data-constants';
import {filtersSelectedDeals, permissionsAccess, useQuery, validateDelayDays} from '../../../helpers/common';
import {
  getInventories,
  getInventoryDeals,
  transferSaled,
  changeContractStatuses,
  getPrintedForm,
  setLoadPraFile,
  changedStatePraModal,
  stateLoader,
  loadPra,
  alertPraState,
  loadPraFailed,
  getAcceptanceCertificate,
} from '../../../redux/actions/contractAction';
import { getListUsers } from '../../../redux/actions/userAction';
import RegisterDetails from './RegisterDetails/RegisterDetails';
import Loader from './Loader/Loader';
import TransferSaledGoHranModal from './TransferSaledGoHranModal/TransferSaledGoHranModal';

import './registerGoHran.scss';

import Arrow from '../../../assets/icons/arrow-down.svg';
import { useHistory } from 'react-router-dom';
import LoadPraModal from "./LoadPraModal/LoadPraModal";
import JSZip from "jszip";
import BasicAlert from "../../utilites/Alert/Alert";
import {messages} from "../../../helpers/messages";

const initialState = {
  currentPage: 1,
  pageRange: pageOptions[0].value,
  reqId: null,
  reqParamTN: [],
  isTransferdSaledGoHran: false,
  isToTransfer: false,
};

const RegisterGoHran = memo(({
                               dealStatus,
                               setError,
                               stateSearch
}) => {
  const {cashBoxIds, fullName, dealNumber, typeDeal, delaysDay, typeDuration} = stateSearch;
  const {
    inventoriesData: { inventories, total },
    isLoading,
    isModalLoading,
    commonError,
    isTabLoading,
    inventory,
    changeContract,
    praFile,
    isPraModal,
    isAlert,
    errorPra,
    praStatus
  } = useSelector(({ contract }) => contract);
  const { listUsers, isLoading: userLoading, accessFeatures } = useSelector(({ user }) => user);
  const dispatch = useDispatch();

  const [state, setState] = useState(initialState);
  const [allChecked, setAllChecked] = useState(false);
  const [TN, setTN] = useState([]);
  const [selectedDeals, setSelectedDeals] = useState([]);
  const [popup, setPopup] = useState({
    isOpen: false,
    type: 'error',
    header: 'Ошибка',
    text: 'Ошибка',
  });
  const notEmpty = TN && TN.length !== 0;
  const gohran = dealStatus === contractStatuses.GOHRAN.param;
  const saledGohran = dealStatus === contractStatuses.SALED_GOHRAN.param;
  const gohranSale = dealStatus === contractStatuses.GOHRAN_SALE.param;

  const history = useHistory();
  const query = useQuery();
  const queryPageRange = query.get('pageRange');
  const queryPage = query.get('page');
  const queryStatus = query.get('dealStatus');
  const refLoadPra = useRef();

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      currentPage: 1,
    }))
  }, [cashBoxIds, dealNumber, typeDeal, fullName, delaysDay, typeDuration])

  useEffect(() => {
    setAllChecked(false);
    return () => {
      setState((prev) => ({
        ...prev,
        currentPage: 1,
        pageRange: pageOptions[0].value,
      }));
    };
  }, [dealStatus]);

  useEffect(() => {
    if(queryStatus === dealStatus) {
      let actualPageRange = state.pageRange;
      let actualPage = state.currentPage;

      if (!!queryPageRange) actualPageRange = +queryPageRange;
      if (!!queryPage) actualPage = +queryPage;
      setState((prev) => ({
        ...prev,
        currentPage: actualPage,
        pageRange: actualPageRange,
      }));
    }
  }, []);

  useEffect(() => {
    history.push({
      search: `?dealStatus=${dealStatus}&pageRange=${state.pageRange}&page=${state.currentPage}`
    })
  }, [dealStatus, state.pageRange, state.currentPage])

  useEffect(() => {
    loadGohranTransfers();
  }, [
    state.pageRange,
    state.currentPage,
    dispatch,
    dealStatus,
    changeContract,
    saledGohran,
    gohranSale,
    gohran,
    cashBoxIds,
    fullName,
    dealNumber,
    typeDeal,
    typeDuration,
    delaysDay
  ]);

  useEffect(() => {
    if (inventories.length) {
      const listUsers = [...new Set(inventories.map(({ userId }) => userId))].join(',');
      dispatch(getListUsers(listUsers));
    }
  }, [inventories, dispatch]);

  useEffect(() => {
    if (inventories && inventories.length && listUsers && listUsers.length) {
      const formattedTN = inventories.map((i) => {
        i.checked = false;
        i.isVisible = false;
        i.userFullName = listUsers.find((user) => user.id === i.userId)
          ? listUsers.find((user) => user.id === i.userId).fullName
          : null;
        return i;
      });
      setState((prev) => ({
        ...prev,
        reqParamTN: formattedTN.map(({ transferId }) => ({
          transferId,
          size: 1000,
          page: 1,
          isTabLoading: false,
        })),
      }));
      setTN(formattedTN);
    } else {
      setTN([]);
    }
  }, [inventories, listUsers]);

  useEffect(() => {
    if (
      TN &&
      TN.length &&
      inventories &&
      inventories.length &&
      !_isEqual(inventory, {}) &&
      inventory.deal.length
    ) {
      const dataInventory = _cloneDeep(TN.find(({ transferId }) => transferId === state.reqId));
      dataInventory.deal = {
        ...inventory,
        deal: inventory.deal.map((i) => {
          i.checked = dataInventory.hasOwnProperty('checked') ? dataInventory.checked : allChecked;
          return i;
        }),
      };

      const ind = TN.findIndex(({ transferId }) => transferId === state.reqId);
      setTN((prev) => [...prev.slice(0, ind), dataInventory, ...prev.slice(ind + 1)]);

      const newReqParam = {
        ...state.reqParamTN.find(({ transferId }) => transferId === state.reqId),
      };
      newReqParam.isTabLoading = false;
      const indx = state.reqParamTN.findIndex(({ transferId }) => transferId === state.reqId);
      setState((prev) => ({
        ...prev,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    }
  }, [inventory]);

  useEffect(() => {
    if (notEmpty) {
      const TNChecked = TN.filter((i) => {
        const arrDeal = TN.filter((i) => i?.deal);
        if (arrDeal.length) {
          if (i.deal?.deal && i.deal.deal.length) {
            return i.deal.deal.filter((item) => item.checked).length || i.checked;
          } else {
            return i.checked;
          }
        } else {
          return i.checked;
        }
      });

      if (TNChecked.length && TN.filter((i) => i?.deal).length) {
        const TNDealChecked = TNChecked.map((i) => {
          if (i?.deal && i.deal.deal.length) {
            if (i.deal.deal.filter((item) => item.checked).length) {
              return {
                ...i,
                deal: {
                  ...i.deal,
                  deal: i.deal.deal.filter((item) => item.checked),
                },
              };
            } else {
              return { ...i, deal: null };
            }
          } else {
            return i;
          }
        });
        setSelectedDeals(TNDealChecked);
      } else {
        setSelectedDeals(TNChecked);
      }
    }
  }, [TN, notEmpty]);

  useEffect(() => {
    if (commonError && state.reqParamTN.length) {
      setState((prev) => ({
        ...prev,
        reqParamTN: prev.reqParamTN.map((i) => ({ ...i, isTabLoading: false })),
      }));
    }
  }, [commonError, state.reqParamTN.length]);

  const loadGohranTransfers = () => {
    const availableDepartaments = JSON.parse(localStorage.getItem('AVAILABLE_DEPARTMENTS'))
    const gohranSaleIds = []
    const transferIds = []
    for (let i = 0; i < dealNumber.length; i++) {
      if (!dealNumber[i].transferId && !dealNumber[i].gohranSaleId) {
        transferIds.push(dealNumber[i].value)
        gohranSaleIds.push(dealNumber[i].value)
      } else {
        transferIds.push(dealNumber[i].transferId)
        gohranSaleIds.push(dealNumber[i].gohranSaleId)
      }
    }
    const validationResult = validateDelayDays(delaysDay);

    if (validationResult) {
      setError(validationResult);
      return;
    } else {
      setError('')
    }
    if (gohran) {
      dispatch(
          getInventories(
              state.pageRange,
              transferIds.length ? 1 : state.currentPage,
              contractStatuses.GOHRAN.param,
              true,
              'transferDate',
              contractStatuses.GOHRAN.param,
              permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                  ? availableDepartaments.join(',')
                  : cashBoxIds.map((i) => i.value).join(','),
              typeDuration.map(i => i.value).join(','),
              fullName.map(i => i.value).join(','),
              transferIds.join(','),
              typeDeal.map(i => i.value).join(','),
              delaysDay.from,
              delaysDay.to,
          ),
      );
    }
    if (saledGohran) {
      dispatch(
          getInventories(
              state.pageRange,
            transferIds.length ? 1 : state.currentPage,
              contractStatuses.GOHRAN.param,
              true,
              'transferDate',
              contractStatuses.SALED_GOHRAN.param,
              permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                  ? availableDepartaments.join(',')
                  : cashBoxIds.map((i) => i.value).join(','),
              typeDuration.map(i => i.value).join(','),
              fullName.map(i => i.value).join(','),
              transferIds.join(','),
              typeDeal.map(i => i.value).join(','),
              delaysDay.from,
              delaysDay.to,
          ),
      );
    }
    if (gohranSale) {
      dispatch(
          getInventories(
              state.pageRange,
            transferIds.length ? 1 : state.currentPage,
              contractStatuses.GOHRAN_SALE.param,
              true,
              'transferDate',
              contractStatuses.SALED_GOHRAN.param,
              permissionsAccess("expired.branch_director.search") && cashBoxIds.length === 0
                  ? availableDepartaments.join(',')
                  : cashBoxIds.map((i) => i.value).join(','),
              typeDuration.map(i => i.value).join(','),
              fullName.map(i => i.value).join(','),
              gohranSaleIds.join(','),
              typeDeal.map(i => i.value).join(','),
              delaysDay.from,
              delaysDay.to,
          ),
      );
    }
  }

  useEffect(() => {
    if (praStatus) {
      checkBoxAfterOperation();
      loadGohranTransfers();
    }
  }, [praStatus]);

  const checkBoxAfterOperation = () => {
    const newArray = _cloneDeep(TN);

    const updatedArray = newArray.map((el) => {
      if (el.deal && el.deal.deal) {
        const updatedDeal = el.deal.deal.map((contract) => ({
          ...contract,
          checked: false,
        }));

        return {
          ...el,
          checked: false,
          deal: {
            ...el.deal,
            deal: updatedDeal,
          },
        };
      } else {
        return {...el, checked: false };
      }
    });
    setTN(updatedArray);
  }

  const onPageRangeChange = useCallback((value) => {
    setState((prev) => ({
      ...prev,
      pageRange: parseInt(value),
      currentPage: 1,
    }));
    setAllChecked(false);
  }, []);

  const handlePageChange = useCallback((page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
    }));
    setAllChecked(false);
  }, []);

  const handleAllContractCheck = useCallback(() => {
    if (notEmpty) {
      const arrDeal = TN.filter((i) => i?.deal);
      if (arrDeal.length !== 0) {
        setTN((prev) =>
          prev.map((item) => {
            if (item?.deal) {
              return {
                ...item,
                checked: !allChecked,
                deal: {
                  ...item.deal,
                  deal: item.deal.deal.map((i) => ({
                    ...i,
                    checked: !allChecked,
                  })),
                },
              };
            } else {
              return {
                ...item,
                checked: !allChecked,
              };
            }
          }),
        );
      } else {
        setTN((prev) =>
          prev.map((item) => ({
            ...item,
            checked: !allChecked,
          })),
        );
      }

      setAllChecked(!allChecked);
    }
  }, [allChecked, TN, notEmpty]);

  const handleTNCheck = useCallback((e) => {
      if (notEmpty) {
        const id = TN.findIndex((item) => item.transferId + item.transferDate === e.target.id);
        const newArray = _cloneDeep(TN);
        newArray[id].checked = !TN[id].checked;

        if (newArray[id].deal?.deal) {
          newArray[id].deal.deal = TN[id].deal.deal.map((i) => ({
            ...i,
            checked: !TN[id].checked,
          }));
        }

        setTN(newArray);
      }
    },
    [TN, notEmpty],
  );

  const handleContractCheck = useCallback(
    (e, transferId) => {
      let tnId = TN.findIndex((item) => item.transferId === transferId);
      let contractId = TN[tnId].deal.deal.findIndex((i) => i.id === +e.target.id);
      let newArray = _cloneDeep(TN);
      newArray[tnId].deal.deal[contractId].checked = !TN[tnId].deal.deal[contractId].checked;
      setTN(newArray);
    },
    [TN],
  );

  const changeVisible = (id) => {
    let ind = TN.findIndex((item) => item.transferId === id);
    let newArray = _cloneDeep(TN);
    newArray[ind].isVisible = !TN[ind].isVisible;
    setTN(newArray);

    const newReqParam = { ...state.reqParamTN.find(({ transferId }) => transferId === id) };
    const indx = state.reqParamTN.findIndex(({ transferId }) => transferId === id);
    const { page, size } = newReqParam;

    if (newArray[ind].isVisible) {
      newReqParam.isTabLoading = true;
      setState((prev) => ({
        ...prev,
        reqId: id,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    } else {
      newReqParam.isTabLoading = false;
      setState((prev) => ({
        ...prev,
        reqId: id,
        reqParamTN: [
          ...prev.reqParamTN.slice(0, indx),
          newReqParam,
          ...prev.reqParamTN.slice(indx + 1),
        ],
      }));
    }

    if (gohran && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.GOHRAN.param, false));
    }
    if (saledGohran && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.SALED_GOHRAN.param, false));
    }
    if (gohranSale && newArray[ind].isVisible) {
      dispatch(getInventoryDeals(size, page, id, contractStatuses.GOHRAN_SALE.param, false));
    }
  };

  const openModal = useCallback(
    (view) => {
      if (selectedDeals.length) {
        setState((prev) => ({ ...prev, [view]: true }));
      }
    },
    [selectedDeals],
  );

  const handleCloseModal = useCallback((view) => {
    setState((prev) => ({ ...prev, [view]: false }));
  }, []);

  const closeAlertModal = useCallback(() => {
    setPopup((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const submitTransferSaledGoHran = useCallback(
    (data) => {
      handleCloseModal(viewDocument.isTransferdSaledGoHran);

      const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);

      if (selectedDeals.length === TN.length && state.currentPage > 1) {
        setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
      }

      const newData = {
        dealIds,
        transferIds,
        status: dealStatus,
        data,
        cash: undefined,
        cashBoxIds: undefined
      }

      if (accessFeatures['report.movement_gohran.json']) {
        dispatch(transferSaled({...newData, getJsonFile: true}));
      } else {
        dispatch(transferSaled({...newData, getJsonFile: false}));
      }

      setAllChecked(false);
    },
    [dispatch, dealStatus, handleCloseModal, selectedDeals, TN.length, state.currentPage],
  );

  const addToTransfer = useCallback(() => {
    handleCloseModal(viewDocument.isToTransfer);

    const { dealIds, transferIds } = filtersSelectedDeals(selectedDeals);

    if (selectedDeals.length === TN.length && state.currentPage > 1) {
      setState((prev) => ({ ...prev, currentPage: prev.currentPage - 1 }));
    }

    if (dealStatus === contractStatuses.GOHRAN_SALE.param) {
      dispatch(
        changeContractStatuses(
          dealIds,
          contractStatuses.TOTRANSFER.param,
          transferIds,
          contractStatuses.SALED_GOHRAN.param,
        ),
      );
    } else {
      dispatch(
        changeContractStatuses(dealIds, contractStatuses.TOTRANSFER.param, transferIds, dealStatus),
      );
    }

    setAllChecked(false);
  }, [handleCloseModal, dispatch, state.currentPage, TN.length, dealStatus, selectedDeals]);

  const closeConfirm = useCallback(
    () => handleCloseModal(viewDocument.isToTransfer),
    [handleCloseModal],
  );

  const printedRegister = (viewReport) => {
    if (selectedDeals.length) {
      if (selectedDeals.length !== 1) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Выберите одну опись',
        }));
        return;
      }

      if (selectedDeals.length === 1 && !selectedDeals[0].checked) {
        setPopup((prev) => ({
          ...prev,
          isOpen: true,
          text: 'Необходимо выбрать опись',
        }));
        return;
      }

      let fileType = gohran ? 'pdf' : 'xlsx';
      if (viewReport === viewReports.MOVEMENT_GOHRAN_JSON) fileType = 'json'
      if (viewReport === viewReports.INTERNAL_MOVEMENT_GOHRAN) fileType = 'pdf'

      const {transferId, isCertificateLoaded, documentNumber} = selectedDeals[0];
      const filename = 'exp_' + transferId + '_' + moment().format('DD.MM.YYYY') + '.' + fileType;
      const filenameCertificate = 'exp_' + transferId + '_' + moment().format('DD.MM.YYYY') + '.json';

      if (isCertificateLoaded && viewReport === viewReports.GOHRAN_REPORT) {
        dispatch(getPrintedForm({transferId}, filename, viewReport, fileType));
        dispatch(getAcceptanceCertificate({transferId, filenameCertificate, type: 'json'}));
      } else {
        dispatch(getPrintedForm({transferId, documentNumber}, filename, viewReport, fileType));
      }

      checkBoxAfterOperation()
    } else {
      setPopup((prev) => ({
        ...prev,
        isOpen: true,
        text: 'Необходимо выбрать опись',
      }));
    }
  };

  const zipFile = (file) => {
    if (!file) {
      return
    }
    const zip = new JSZip();
    zip.file(file.name, file);

    return zip.generateAsync({type: 'blob', compression: 'DEFLATE'});
  }

  const onChangeFileLoadPra = (event) => {
    dispatch(loadPraFailed(''));
    const allowedFileZip = ['application/json'];
    const file = event.target.files[0];
    if (file && allowedFileZip.includes(file.type)) {
      dispatch(setLoadPraFile(event.target.files[0]));
    } else {
      dispatch(loadPraFailed(messages[17107]));
    }
    refLoadPra.current.value = '';
  }

  const submitLoadPra = async () => {
    dispatch(stateLoader(true))
    const file = await zipFile(praFile);
    dispatch(loadPra({
      transferId: selectedDeals[0].transferId,
      file
    }))
    refLoadPra.current.value = '';
    dispatch(setLoadPraFile(null));
  }

  const handleClearPraFile = () => {
    refLoadPra.current.value = '';
    dispatch(loadPraFailed(''));
    dispatch(setLoadPraFile(null));
  }
  const openPraModal = () => {
    if (selectedDeals.length !== 1) {
      setPopup((prev) => ({
        ...prev,
        isOpen: true,
        text: 'Выберите одну опись',
      }));
      return
    } else {
      dispatch(changedStatePraModal(true));
    }
  }

  const closePraModal = () => {
    refLoadPra.current.value = '';
    dispatch(setLoadPraFile(null));
    dispatch(changedStatePraModal(false));
    dispatch(loadPraFailed(''));
  }

  const onCloseAlert = () => dispatch(alertPraState());

  return (
    <>
      {commonError && <Message type="error" text={commonError} />}
      {isModalLoading && <Message type="info" text={'Подождите, идёт формирование описи'} />}
      <div className="content-datatable">
        <div className="content-datatable-header sticky">
          <div className="content-datatable-header-left registerGoHran-content">
            <div className="action-items">
              {
                permissionsAccess("action.deal.status.transfer.totransfer") &&
                <ActionButton
                  text="Вернуть на передачу"
                  func={openModal}
                  param={viewDocument.isToTransfer}
                />
              }
              {
                  gohranSale &&
                  permissionsAccess("report.gohran.load.acceptance_cert") &&
                  accessFeatures['report.gohran.acceptance_cert'] &&
                  <ActionButton text="Загрузить файл ПРА" func={openPraModal} />
              }

              {gohran && permissionsAccess("action.deal.sale.gohran") &&
                  <ActionButton
                    text="Сформировать опись"
                    func={openModal}
                    param={viewDocument.isTransferdSaledGoHran}
                  />
              }
              {(saledGohran || gohranSale) && permissionsAccess("action.overdue.load.aiskb") &&
                  <ActionButton text="Передача данных в АИС КБ" />
              }
              {
                gohran && permissionsAccess("action.report.generate.gohran") &&
                  <ActionButton func={() => printedRegister(viewReports.INTERNAL_MOVEMENT_GOHRAN)} text="Печать"/>
              }
              {
                  saledGohran && permissionsAccess("action.report.generate.archive") &&
                  <ActionButton func={() => printedRegister(viewReports.MOVEMENT_GOHRAN)} text="Печать"/>
              }
              {
                gohranSale && permissionsAccess("action.report.generate.saled_gohran") &&
                  <ActionButton func={() => printedRegister(viewReports.MOVEMENT_GOHRAN)} text="Печать"/>
              }
              {
                gohranSale && permissionsAccess("report.generate.gohran") && accessFeatures['report.gohran'] &&
                  <>
                    <ActionButton
                        func={() => printedRegister(viewReports.GOHRAN_REPORT)}
                        text="Отчет Гохран"/>
                    <ActionButton
                        func={() => printedRegister(viewReports.MOVEMENT_GOHRAN_JSON)}
                        text="Выгрузка описи в Гохран"
                    />
                  </>


              }
            </div>
          </div>
          <div className="content-datatable-header-right">
            <ShowItemsSelectPageCount
              wrapClass={'padding-select'}
              options={pageOptions}
              change={onPageRangeChange}
              statePageRange={state.pageRange}
            />
          </div>
        </div>
        <div className="content-datatable-content">
          {isLoading || userLoading ? (
            <Loader pageRange={state.pageRange} />
          ) : (
            <table className={isTabLoading ? 'table' : 'table hover'}>
              <thead>
                <tr className="registerGoHran-table-header">
                  <th scope="col">
                    <Checkbox
                      label="Номер"
                      id="checkboxContractSelectAll"
                      name="checkboxContractSelectAll"
                      onChange={handleAllContractCheck}
                      value={allChecked}
                    />
                  </th>
                  <th scope="col">
                    <p>
                      Тип <br />
                      документа
                    </p>
                  </th>
                  <th scope="col">
                    <p>Отправитель</p>
                  </th>
                  {gohranSale ? null : (
                    <th scope="col">
                      <p>Получатель</p>
                    </th>
                  )}
                  <th scope="col">
                    <p>Дата</p>
                  </th>
                  <th scope="col">
                    <p>Пользователь</p>
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {notEmpty &&
                  TN.map((tn, ind) => {
                    return (
                      <Fragment key={tn.transferId}>
                        <tr>
                          <td>
                            <div className="table-cellcontent">
                              <Checkbox
                                id={tn.transferId + tn.transferDate}
                                name={tn.transferId}
                                onChange={handleTNCheck}
                                value={tn.checked}
                              />
                              <p>{tn.documentNumber}</p>
                            </div>
                          </td>
                          <td>
                            {
                              tn.isCertificateLoaded ? <p>Опись/ПРА</p> : <p>Опись</p>
                            }
                          </td>
                          <td>
                            <p>{tn.sendCashboxName}</p>
                          </td>
                          {gohranSale ? null : (
                            <td>
                              <p>{tn.destCashboxName}</p>
                            </td>
                          )}
                          <td>
                            <p>{moment(tn.transferDate).format('DD.MM.YYYY')}</p>
                          </td>
                          <td>
                            <p>{tn.userFullName}</p>
                          </td>
                          <td
                            className={`registerGoHran-table-col-arrow${
                              tn.isVisible ? '-up' : ''
                            }`}>
                            <Arrow onClick={() => changeVisible(tn.transferId)} />
                          </td>
                        </tr>
                        <tr
                          className={`registerGoHran-table-line${tn.isVisible ? '-visible' : ''}`}>
                          <td colSpan="7">
                            <RegisterDetails
                              key={tn.transferId}
                              tn={tn?.deal}
                              transferId={tn.transferId}
                              isTabLoading={state.reqParamTN[ind].isTabLoading}
                              handleContractCheck={handleContractCheck}
                            />
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <BasicAlert
        onClose={onCloseAlert}
        message='Файл ПРА успешно загружен'
        isOpen={isAlert}
      />
      <Pagination
        total={Math.ceil(total / state.pageRange)}
        current={state.currentPage}
        handlePageChange={handlePageChange}
      />
      <TransferSaledGoHranModal
        isOpen={state.isTransferdSaledGoHran}
        submitTransferSaledStore={submitTransferSaledGoHran}
        handleCloseModal={handleCloseModal}
      />
      <ConfirmModal
        isOpen={state.isToTransfer}
        handleClose={closeConfirm}
        handleAction={addToTransfer}
        headerText="Вы хотите переместить на передачу?"
      />
      <AlertModal
        isOpen={popup.isOpen}
        handleClose={closeAlertModal}
        header={popup.header}
        text={popup.text}
      />
      <LoadPraModal
          isLoading={isLoading}
          isOpen={isPraModal}
          onChangeFileLoadPra={onChangeFileLoadPra}
          praFile={praFile}
          closePraModal={closePraModal}
          selectedDeal={selectedDeals[0]}
          commonError={errorPra}
          refLoadPra={refLoadPra}
          handleClearPraFile={handleClearPraFile}
          submitLoadPra={submitLoadPra}
      />
    </>
  );
});

export default RegisterGoHran;
